module.exports = __webpack_public_path__ + "img/app-down.45a99a3f.jpg";